import { useEffect, useMemo, useState } from "react";
import { publicSiteService } from "../services/publicSiteService";
import { PublicRaceLaunchContextValue, PublicRaceLaunchPhase, readEmbeddedLaunchPhase } from './publicRaceLaunchPresentation';

const defaultServices = { get publicSiteService() { return publicSiteService; } };

export function usePublicRaceLaunchViewModel(services = defaultServices) {
  const { publicSiteService } = services;

  const [phase, setPhase] = useState<PublicRaceLaunchPhase>(readEmbeddedLaunchPhase);

  useEffect(() => {
    let active = true;
    const unsubscribe = publicSiteService.subscribeLaunch(
      live => { if (active) setPhase(live ? "live" : "prelaunch"); },
      () => { if (active) setPhase(current => current === "checking" ? "error" : current); }
    );
    return () => { active = false; unsubscribe(); };
  }, [publicSiteService]);

  const contextValue = useMemo<PublicRaceLaunchContextValue>(
    () => ({
      phase,
      hasPublicRaces: phase === "live",
      isResolved: phase === "prelaunch" || phase === "live",
    }),
    [phase]
  );
  return { contextValue };
}
